import React, { useEffect, useRef, useState } from "react";
import NotificacionAuth from "../NotificacionAuth/NotificacionAuth";
import InptContraseña from "../InptContraseña/InptContraseña";
import { useNavigate } from "react-router-dom";
import LoginEntity from "../../core/entities/loginEntity";
import { fetchLogin } from "./services/uModalLoginService";
import NotificacionEntity from "../../core/entities/notificacionEntity";
import { ThreeDots } from "react-loader-spinner";
import GeneralInput from "../GeneralInput/GeneralInput";
import "./UModalLogin.module.css";

export default function UModalLogin({
  vIsLogin = false,
  mActivar_DesactivarModal = () => {},
}) {
  // Manejo de estados locales
  const [vIsCargandoResp, setvIsCargandoResp] = useState(false);
  const [credenciales, setCredenciales] = useState(new LoginEntity());

  const navigate = useNavigate(); // Hook para redirigir al usuario

  // Hook de efectos secundarios
  useEffect(() => {
    if (vIsLogin) {
      localStorage.removeItem("password_old");
      if (localStorage.getItem("token") !== null) {
        localStorage.setItem("login",true)
        navigate("/alumno");
      } else {
        localStorage.clear();
      }
    }
  }, [vIsLogin]);

  // Referencias a elementos del DOM
  const correoRef = useRef(null);
  const contraseñaRef = useRef(null);
  const notificacionRef = useRef(null);

  // Manejo de entradas
  const handleInpCorreo = (evt) => {
    setCredenciales(new LoginEntity(evt.target.value, credenciales.password));
  };
  const handleInpPass = (evt) => {
    setCredenciales(new LoginEntity(credenciales.email, evt.target.value));
  };

  // Manejo del proceso de inicio de sesión
  const handleLogin = () => {
    console.log(correoRef.current.value);
    setCredenciales(
      new LoginEntity(correoRef.current.value, contraseñaRef.current.value)
    );
    if (!vIsCargandoResp) {
      setvIsCargandoResp(true);
      const errores = credenciales.validar();

      if (errores.length > 0) {
        notificacionRef.current.show(
          new NotificacionEntity("Error de validación", errores[0], "rojo", 10)
        );
        setvIsCargandoResp(false);
        return;
      }
      notificacionRef.current.hide();
      fetchLogin(credenciales)
        .then((response) => {
          setvIsCargandoResp(false);

          if (response.ok) {
            return response.json();
          }

          // Manejo de diferentes tipos de errores basados en el código de estado
          switch (response.status) {
            case 401:
              response.json().then((result) => {
                const tiempo = 15;
                switch (result.detail.acción) {
                  case "NUEVA_CONTRASEÑA_REQUERIDA":
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Nueva contraseña requerida",
                        result.detail.detalle,
                        "rojo",
                        15
                      )
                    );

                  case "RESET_PASSWORD":
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Reinicio de contraseña requerido",
                        `${result.detail.detalle}, da click en "olvide la contraseña" `,
                        "rojo",
                        15
                      )
                    );
                  case "CONFIRM_SIGN_UP":
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Usuario no confirmado",
                        result.detail.detalle,
                        "rojo",
                        15
                      )
                    );
                  default:
                    notificacionRef.current.show(
                      new NotificacionEntity(
                        "Credenciales invalidas",
                        result.detail.detalle,
                        "rojo",
                        15
                      )
                    );
                }
              });
            case 400:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Solicitud incorrecta",
                  "Hay un problema con los datos enviados.",
                  "amarillo",
                  10
                )
              );
            case 404:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Recurso no encontrado",
                  "El recurso solicitado no existe en el servidor.",
                  "amarillo",
                  10
                )
              );
              throw new Error("ERR_ME");
            case 500:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Error del servidor",
                  "Ocurrió un error en el servidor. Inténtalo de nuevo más tarde.",
                  "rojo",
                  10
                )
              );
              throw new Error("ERR_ME");
            default:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Error desconocido",
                  "Ocurrió un error inesperado.",
                  "rojo",
                  10
                )
              );
              throw new Error("ERR_ME");
          }
        })
        .then((result) => {
          if (result !== undefined) {
            switch (result["detail"]["acción"]) {
              case "NUEVA_CONTRASEÑA_REQUERIDA":
                localStorage.setItem("password_old", credenciales.password);
                navigate(result["detail"]["endpoint_cambio_contraseña"] + "");
                break;
              case "LOGIN_EXITOSO":
                const { token, user_id } = result["detail"]["datos"];
                localStorage.setItem("token", token);
                localStorage.setItem("usuario_id", user_id);
                navigate("/alumno");
                break;

              default:
                notificacionRef.current.show(
                  new NotificacionEntity(
                    "Error desconocido",
                    "Ocurrió un error inesperado.",
                    "rojo",
                    10
                  )
                );
                break;
            }
          }
        })
        .catch((error) => {
          // Separar las propiedades del error
          const { message } = error;
          if (message !== "ERR_ME") {
            notificacionRef.current.show(
              new NotificacionEntity(
                "Error de red",
                "No se pudo conectar con el servidor.",
                "rojo",
                10
              )
            );
          }
          setvIsCargandoResp(false);
        });
    }
  };

  if (!vIsLogin) {
    return null;
  }

  return (
    <div class="box-modals-publico">
      <div data-figma-id="933:13496" class="login">
        <div data-figma-id="933:13453" class="login-info-1">
          <div data-figma-id="933:13454" class="login-titulos">
            <p data-figma-id="933:13455" class="login-titulo-1">
              SIGUE APRENDIENDO
            </p>
            <p data-figma-id="933:13456" class="login-titulo-2">
              Ingresa a tu cuenta.
            </p>
            <div data-figma-id="933:13457" class="div-block-12">
              <p data-figma-id="933:13457 - 0" class="login-titulo-3">
                ¿No tienes una cuenta?{" "}
              </p>
              <p
                data-figma-id="933:13457 - 1"
                class="login-titulo-3-2"
                onClick={() => mActivar_DesactivarModal("contactanos", true)}
              >
                Solicítala aquí
              </p>
            </div>
          </div>
          <div data-figma-id="933:13459" class="login-info">
            <div data-figma-id="933:13460" class="login-apartados">
              <GeneralInput
                type="email"
                titulo="Correo electrónico"
                placeholder="ejemplo@ejem.ej"
                ref={correoRef}
                onChange={handleInpCorreo}
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
              />
              <InptContraseña
                onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                contraseñaRef={contraseñaRef}
                handleInpPass={handleInpPass}
              />
            </div>
            <p
              data-figma-id="933:13463"
              class="login-texto"
              onClick={() => mActivar_DesactivarModal("enviarCorreo", true)}
            >
              ¿Olvidaste tu contraseña?
            </p>
            <div data-figma-id="933:13464" class="login-botones">
              <div
                data-figma-id="933:13821"
                class="boton-cancelar-2"
                onClick={() => mActivar_DesactivarModal("", false)}
              >
                <p data-figma-id="933:13822" class="boton-cancelar-texto-2">
                  Cancelar
                </p>
              </div>
              <div
                data-figma-id="933:13823"
                class="boton-login"
                onClick={handleLogin}
                style={
                  vIsCargandoResp
                    ? { cursor: "wait", backgroundColor: "#37888De6" }
                    : {}
                }
              >
                {vIsCargandoResp ? (
                  <ThreeDots
                    height="30"
                    width="30"
                    color="#fff"
                    radius="1"
                    ariaLabel="three-dots-loading"
                  />
                ) : (
                  <p data-figma-id="933:13824" class="boton-login-texto">
                    Iniciar sesión
                  </p>
                )}
              </div>
            </div>
          </div>
          <NotificacionAuth
            ref={notificacionRef} // Usando la referencia
          />
        </div>
        <div data-figma-id="933:13467" class="login-info-2">
          <div data-figma-id="933:13468" class="login-imagen-info">
            <div data-figma-id="933:13469" class="login-cita">
              <p data-figma-id="933:13470" class="cita-comillas">
                “
              </p>
              <p data-figma-id="933:13471" class="cita-texto">
                Si crees que la educación es cara, prueba con la ignorancia.
              </p>
              <p data-figma-id="933:13472" class="cita-autor">
                - Derek Bok
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
